import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ReactVimeo from 'components/consumer/ReactVimeo';
const SingleHeroVideoVimeo = t0 => {
  const $ = _c(6);
  const {
    videoId: t1,
    autoplay: t2
  } = t0;
  const videoId = t1 === undefined ? "https://vimeo.com/manage/videos/560538232" : t1;
  const autoplay = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== videoId) {
    t3 = videoId ? videoId.replace("/manage/videos", "") : videoId;
    $[0] = videoId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const vimeoVideoId = t3;
  let t4;
  if ($[2] !== autoplay || $[3] !== videoId || $[4] !== vimeoVideoId) {
    t4 = !!videoId && <div className="SingleHeroVideoCore"><div className="px-0 py-[56.25%0] relative"><div className="h-full left-0 top-0 w-full"><ReactVimeo className="SingleHeroVideo__video--vimeo" video={vimeoVideoId} responsive={true} autoplay={autoplay || undefined} showTitle={false} /></div></div></div>;
    $[2] = autoplay;
    $[3] = videoId;
    $[4] = vimeoVideoId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
SingleHeroVideoVimeo.propTypes = {
  videoId: PropTypes.string,
  autoplay: PropTypes.bool
};
export default SingleHeroVideoVimeo;